// extracted by mini-css-extract-plugin
export default {"background":"errorBoundary_background__6Ma8+"};